/* eslint-disable no-nested-ternary */
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import RoomTypeCard from '../room-types/room-type-card.component';


const FeaturedSpacesMobileCarousel = (props) => {
   
    const { data, title, selectedCity, selectedBuilding, href } = props;
    const carouselTitle = title || 'Featured Articles';
    const linkHref = href || '/bookings';
    const visibleData = _.slice(data, 0, 6);
    const dataLength = _.size(visibleData);

    const getScreenWidth = (referenceWidth) => {
        return window.innerWidth <= referenceWidth ? referenceWidth : 1920;
    };    

    const containerRef = useRef(null);
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [transformValue, setTransformValue] = useState(0);
    const [cardWidth, setCardWidth] = useState(getScreenWidth(412));

    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentX, setCurrentX] = useState(0);
    const [diffX, setDiffX] = useState(0);    

    useEffect(() => {
        const handleResize = () => {
            setCardWidth(getScreenWidth(1366));
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {        
        if (!containerRef.current) return;

        const container = containerRef.current;
        const activeCard = container.querySelectorAll('.mobile-blog-carousel-slide')[currentCardIndex];
        if (!activeCard) return;

        const containerWidth = container.parentElement.offsetWidth;
        const cardRect = activeCard.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        
        const cardCenter = cardRect.left + cardRect.width / 2;
        const containerCenter = containerRect.left + containerWidth / 2;

        setTransformValue(containerCenter - cardCenter);       
       
    }, [currentCardIndex, cardWidth]);

    const handleStart = (e) => {
        setIsDragging(true);
        // Use e.clientX for mouse events and e.touches[0].clientX for touch events
        setStartX(e.clientX || e.touches[0].clientX);
    };

    const handleMove = (e) => {
        if (!isDragging) return;
        const newCurrentX = e.clientX || e.touches[0].clientX;
        const newDiffX = newCurrentX - startX;
        setCurrentX(newCurrentX);
        setDiffX(newDiffX);
    };

    const handleEnd = () => {
        setIsDragging(false);
        if (diffX > 50) {
            // Dragged right, go to previous card
            goToPreviousCard();
        } else if (diffX < -50) {
            // Dragged left, go to next card
            goToNextCard();
        }
        setDiffX(0); // Reset the difference
    };    

    const goToNextCard = () => {
        if (currentCardIndex < dataLength - 1) {
            const newIndex = currentCardIndex + 1;
            setCurrentCardIndex(newIndex);
        } else {
            setCurrentCardIndex(0);
        }
    };

    const goToPreviousCard = () => {
        if (currentCardIndex > 0) {
            const newIndex = currentCardIndex - 1;
            setCurrentCardIndex(newIndex);
        } else {
            setCurrentCardIndex(dataLength - 1);
        }
    };
    
    const trackWidth = `${dataLength * 100}%`;
    const wrapperWidth = `${(100 / dataLength).toFixed(5)}%`;    

    return (
        <div className='carousel-container-mobile'>
            <h4>
                {carouselTitle} in {selectedCity || selectedBuilding}
            </h4>
            <p className='carousel-container-mobile-paragraph'>Your space is waiting for you</p>
            <div id='mobile-blog-carousel'>
                <div className='mobile-blog-carousel-horizontal-slider'>
                    <div className='mobile-blog-carousel-slider-tray-wrapper'>
                        <ul ref={containerRef} className='mobile-blog-carousel-slider-tray' 
                            style={{ width: trackWidth, transform: `translate3d(${transformValue}px, 0px, 0px)` }}
                            onMouseDown={handleStart}
                            onMouseMove={handleMove}
                            onMouseUp={handleEnd}
                            onMouseLeave={handleEnd} 
                            onTouchStart={handleStart}
                            onTouchMove={handleMove}
                            onTouchEnd={handleEnd}                            
                            >
                            {visibleData.map((roomType, index) => (
                                <div key={index}>
                                    <li index={index} key={index} className="mobile-blog-carousel-slide"
                                        style={{ width: wrapperWidth, paddingBottom: '20%' }}>
                                        <div className='mobile-blog-carousel-slide-inner'>
                                            <div className='mobile-blog-carousel-slide-item'>
                                                <RoomTypeCard roomType={roomType} noFade />
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            ))}
                        </ul>                        
                    </div>
                </div>
                <div className="buttons-container-mobile">
                    <div>
                        <a href={linkHref} id="browse-more-rooms">Browse All</a>
                    </div>
                    <div className="nav-button-container-mobile">
                        <button
                            type="button" aria-label="Back"     
                            onClick={goToPreviousCard}
                            role="button" aria-disabled="false" id="blog-carousel-back" className='blog-carousel-button'>
                            <span
                                className="blog-carousel-label"><svg
                                    className="blog-carousel-icon-root"
                                    focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        d="M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z">
                                    </path>
                                </svg>
                            </span>
                            <span className="blog-carousel-ripple-root"></span>
                        </button>
                        <button type="button" aria-label="Next"   
                            onClick={goToNextCard}
                            role="button" aria-disabled="false" id="blog-carousel-next" className='blog-carousel-button'>
                            <span
                                className="blog-carousel-label"><svg
                                    className="blog-carousel-icon-root"
                                    focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path
                                        d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59c.39-.39.39-1.02 0-1.41l-6.58-6.6a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z">
                                    </path>
                                </svg>
                            </span>
                            <span className="blog-carousel-ripple-root"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturedSpacesMobileCarousel;

FeaturedSpacesMobileCarousel.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string,
    selectedCity: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    selectedBuilding: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    href: PropTypes.string,
};


